import React, { useCallback, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import Button from "../../atoms/Button";
import Loader from "../../atoms/Loader";
import Logotype from "../../atoms/Logotype";
import { StoreContext } from "../../../contexts";
import { APPLICATION_ROUTES } from "../../../constants";
import { useQuery } from "../../../hooks";
import { ACTIONS } from "../../../store";
import { getErrorTranslationKey } from "./utilities";

const EmailVerificationRequest = observer(() => {
  const { authorization } = useContext(StoreContext);
  const isLoading =
    authorization[`isLoading${ACTIONS.AUTHORIZATION.VERIFY_EMAIL}`];
  const error = authorization[`error${ACTIONS.AUTHORIZATION.VERIFY_EMAIL}`];
  const errorTranslationKey = getErrorTranslationKey(error);
  const isEmailResend =
    authorization[`success${ACTIONS.AUTHORIZATION.RESEND_EMAIL_VERIFICATION}`];

  const history = useHistory();

  const query = useQuery();
  const token = query.get("token");
  const email = query.get('email');
  const isLoadingResendEmailVerification =
    authorization[
    `isLoading${ACTIONS.AUTHORIZATION.RESEND_EMAIL_VERIFICATION}`
    ];

  const onSubmit = useCallback(() => {
    authorization.verifyEmail({
      token,
      onSuccess: () => {
        history.push(`${APPLICATION_ROUTES.PARTNERS_MAIN_HOME}?scroll=true`);
      },
    });
  }, []);

  const resendEmailVerification = () => {
    authorization.resendEmailVerification({
      email: email,
      onSuccess: () => {
        // history.push(`${APPLICATION_ROUTES.VERIFY_EMAIL}?email=${email}`);
      },
    });
  };


  useEffect(() => {
    if (error == "404") {
      resendEmailVerification();
    }
  }, [error]);

  useEffect(() => {
    onSubmit();
  }, []);

  useEffect(() => {
    if (authorization.errorResendEmailVerification == "already_verified") {
      window.location.href = `${APPLICATION_ROUTES.SIGN_IN}?email-verified=true`;
    }
  }, [authorization.errorResendEmailVerification]);

  let userEmail;

  if (authorization.isAuthenticated) {
    userEmail = authorization.user.email;
  } else {
    userEmail = query.get("email");
  }

  const openMail = () => {
    if (userEmail) {
      const emailDomain = userEmail?.split("@")[1].toLowerCase();

      switch (emailDomain) {
        case "gmail.com":
          window.location.href = "https://mail.google.com/";
          break;
        case "yahoo.com":
          window.location.href = "https://mail.yahoo.com/";
          break;
        case "hotmail.com":
          window.location.href = "https://outlook.live.com/owa/";
          break;
        case "aol.com":
          window.location.href = "https://mail.aol.com/";
          break;
        case "outlook.com":
          window.location.href = "https://outlook.live.com/owa/";
          break;
        default:
          window.location.href = "https://mail.google.com/";
      }
    }
  };

  const { t } = useTranslation();

  return (
    <main className="bg-gold-gradient--horizontal c-grey-dark text-m">
      <div className="wrapper-s wrapper-vertical-s-a d-flex fd-column ai-center minh-100vh">
        <nav>
          <Logotype />
        </nav>

        {isLoading && (
          <>
            <div className="mt-07">
              <p>Verifying...</p>
              <div className="mt-02">
                <Loader />
              </div>
            </div>
          </>
        )}

        {
          error && !isLoading && !isEmailResend && !isLoadingResendEmailVerification &&
          <div
            className="mt-07 mb-07 w-100p ta-center c-red"
            style={{ maxWidth: "320px" }}
          >{t(errorTranslationKey)}
          </div>
        }

        {isEmailResend && error && !isLoadingResendEmailVerification && (
          <>
            <div
              className="mt-07 mb-07 w-100p ta-center c-red"
              style={{ maxWidth: "320px" }}
            >
              {t("authorization.email_resend_message")}
            </div>

            <div className={("mt-10")}>
              <Button borderRadius="8" size="m" stretched onClick={openMail}>
                Check your Email
              </Button>
            </div>
          </>
        )}
      </div>
    </main>
  );
});

export default EmailVerificationRequest;
